module.exports = __webpack_public_path__ + "static/media/dex-contact-leads.cda6b18d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/dex-contact-leads.png
// module id = 255
// module chunks = 1